<template>
  <div class="card">
    <div class="background">
      <img class="logo" src="@/assets/logo2.png" alt="QuickMatrixTool 应用图标" />
      <p class="title">快速启动工具</p>
      <p class="description2">超轻便,超简洁,超高效</p>
      <p class="description">极大提高电脑上的操作效率</p>
      <button class="download_btn" @click="download">立马体验</button>
      <p class="platform-tip">支持 Windows 7 及以上</p>
      <p class="platform-tip platform-tip-mobile">本工具为 Windows 桌面应用,建议前往 PC 端下载使用</p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    download() {
      this.$downloadClient()
    }
  }
}
</script>

<style scoped>
img.logo {
  margin-top: 8%;
  border-radius: 8px;
  width: 96px;
  height: auto;
}

.title {
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  font-size: 3.75rem;
  line-height: 4.25rem;
  font-weight: 700;
  color: #fff;
  font-family: Inter, "Noto Sans", "Segoe UI", Avenir, Helvetica, Arial, sans-serif;
}

.description2 {
  margin: 8px;
  font-size: 1.75rem;
  font-weight: 500;
  color: #eee;
}

.description {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 500;
  color: #eee;
}

@media (max-width: 768px) {
  img.logo {
    width: 72px;
    margin-top: 32px;
  }
  .title {
    font-size: 2rem;
    line-height: 2.5rem;
    margin: 12px 0;
  }
  .description2,
  .description {
    font-size: 1.05rem;
  }
}
</style>
